import { Controller } from '@hotwired/stimulus'

export const OPEN_SUPPORT_WIDGET = 'support-request:open'

// The launcher lives in the nav while the panel is rendered by the layout, so they
// talk over a document event rather than a shared Stimulus scope.
export default class extends Controller {
  open = () => {
    document.dispatchEvent(new CustomEvent(OPEN_SUPPORT_WIDGET, { detail: { launcher: this.element } }))
  }
}
